module.exports = __webpack_public_path__ + "static/media/partner5.520e86dc.jpg";